// extracted by mini-css-extract-plugin
module.exports = {"section":"styles_section__PcfbL","sectionEditable":"styles_sectionEditable__a_ltM","sectionHeader":"styles_sectionHeader__dxRDZ","arrow":"styles_arrow__R_xu1"};